import styled from 'styled-components';

export const Container = styled.form`
  width: 70%;
  height: fit-content;
  margin: 2rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
